module.exports = {
  platform: 'voice',
  name: 'Clear Retry',
  node: 'clear_retry',
  bg: '#FFFFFF',
  note: ''
}
